import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type MarkAllNotificationsAsReadMutationVariables = Types.Exact<{
  input: Types.MarkAllNotificationsAsReadInput;
}>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead?: { __typename?: 'MarkAllNotificationsAsReadPayload', successful?: boolean | null } | null };


export const MarkAllNotificationsAsRead = /*#__PURE__*/ gql`
    mutation MarkAllNotificationsAsRead($input: MarkAllNotificationsAsReadInput!) {
  markAllNotificationsAsRead(input: $input) {
    successful
  }
}
    ` as unknown as DocumentNode<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

          

          export const useMarkAllNotificationsAsReadMutation = (options?:MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) => useMutation(MarkAllNotificationsAsRead, options);
          

          export type MarkAllNotificationsAsReadMutationOptions = MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

          

          export type MarkAllNotificationsAsReadMutationResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>[1];

          
